import { useCart } from './context/CartContext';
import { initiatePayment } from './services/stripe';
import { useNavigate } from 'react-router-dom';
import './styles/Cart.css';

const Cart = () => {
  const { cart, removeFromCart, updateQuantity, clearCart } = useCart();
  const navigate = useNavigate();

  const handleCheckout = async () => {
    try {
      // For now, we'll just process the first paid item
      const paidItem = cart.items.find(item => item.tool.price > 0);
      if (paidItem) {
        await initiatePayment(paidItem.tool.id, paidItem.tool.price);
      } else {
        // Handle free tools
        console.log('Processing free tools...');
        clearCart();
        navigate('/business-tool-marketplace?success=true');
      }
    } catch (error) {
      console.error('Checkout failed:', error);
    }
  };

  if (cart.items.length === 0) {
    return (
      <div className='cart-container'>
      <div className="cart-empty">
        <h2>Your cart is empty</h2>
        <button onClick={() => navigate('/')} className="browse-button">
          Browse Tools
        </button>
      </div>
      </div>
    );
  }

  return (
    <div className='cart-container'>
      <div className="cart">
        <h1>Shopping Cart</h1>
        <div className="cart-items">
          {cart.items.map(item => (
            <div key={item.tool.id} className="cart-item">
              <div className="item-info">
                <h3>{item.tool.title}</h3>
                <p className="item-author">By {item.tool.author}</p>
                <p className="item-price">
                  {item.tool.price === 0 ? 'Free' : `$${item.tool.price.toFixed(2)}`}
                </p>
              </div>
              <div className="item-actions">
                <div className="quantity-controls">
                  <button
                    onClick={() => updateQuantity(item.tool.id, item.quantity - 1)}
                    className="quantity-button"
                  >
                    -
                  </button>
                  <span className="quantity">{item.quantity}</span>
                  <button
                    onClick={() => updateQuantity(item.tool.id, item.quantity + 1)}
                    className="quantity-button"
                  >
                    +
                  </button>
                </div>
                <button
                  onClick={() => removeFromCart(item.tool.id)}
                  className="remove-button"
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="cart-summary">
          <div className="subtotal">
            <span>Subtotal:</span>
            <span>${cart.subtotal.toFixed(2)}</span>
          </div>
          <button onClick={handleCheckout} className="checkout-button">
            {cart.subtotal === 0 ? 'Download Free Tools' : 'Checkout with Stripe'}
          </button>
        </div>
      </div>
    </div>
  );
};
export default Cart;